import { render, staticRenderFns } from "./EmailWindow.vue?vue&type=template&id=31340342"
import script from "./EmailWindow.vue?vue&type=script&lang=js"
export * from "./EmailWindow.vue?vue&type=script&lang=js"
import style0 from "./EmailWindow.vue?vue&type=style&index=0&id=31340342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports